export default function addBaseline(data, baselineFct) {
    if (!baselineFct)
        return data;
    const xs = data.x;
    const ys = data.y;
    for (let i = 0; i < xs.length; i++) {
        ys[i] += baselineFct(xs[i]);
    }
    return data;
}
//# sourceMappingURL=addBaseline.js.map